import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@ts-digital/vrc/es/components/button";
import Tooltip, { TooltipTextPosition } from "../Tooltip";
import "./style.css";

interface CustomButtonProps {
    kind?: string;
    className?: string;
    onClick: Function;
    disabled?: boolean;
    loading?: boolean;
    children?: any;
    colorScheme?: string;
    icon?: any;
    size?: string;
    tooltipText?: React.ReactNode | string;
}

export const CustomButton = ({
    kind,
    className,
    onClick,
    disabled,
    loading,
    children,
    colorScheme,
    icon,
    size,
    tooltipText,
}: CustomButtonProps) => {
    function renderContent() {
        return (
            <>
                {loading ? (
                    <FontAwesomeIcon
                        icon={faCircleNotch as IconProp}
                        className="fa-spin c-CustomButton-loading-icon"
                    />
                ) : icon ? (
                    icon
                ) : undefined}

                {children}
            </>
        );
    }

    return (
        <Button
            kind={kind}
            colorScheme={colorScheme}
            size={size}
            className={className}
            onClick={onClick}
            disabled={disabled || loading}
        >
            {tooltipText ? (
                <Tooltip
                    text={tooltipText}
                    position={TooltipTextPosition.Left}
                    hasSmallChildren={!children && icon}
                >
                    {renderContent()}
                </Tooltip>
            ) : (
                renderContent()
            )}
        </Button>
    );
};
